<template>
	<v-app :style="'background-image: url('+require('@/assets/images/login_page_image2.jpg')+'); background-position: center center; background-size: cover;'">
		<v-container>
			<v-row class="pt-14 px-5">
				<div>
					<img width="140px" src="@/assets/images/qamtu_logo_blue.png" />
				</div>
				<v-spacer></v-spacer>
				<v-menu offset-y>
					<template v-slot:activator="{ on, attrs }">
						<v-btn
							depressed
							dark
							class="lang-btn"
							v-bind="attrs"
							v-on="on"
						>
							{{languages[selectedLanguage]}}
						</v-btn>
						</template>
						<v-list>
							<v-list-item
								link
								v-for="(item, index) in languages"
								:key="index"
								@click.stop="changeLanguage(index)"
							>
								<v-list-item-title>{{ item }}</v-list-item-title>
							</v-list-item>
						</v-list>
				</v-menu>
			</v-row>
			<v-row>
				<v-col xl="4" lg="6" md="7" sm="9" align-center justify-center>
					<div class="auth-block">
						<h2 class="text-center mb-12">{{ $t('Добро пожаловать в Личный кабинет!') }}</h2>
						
						<v-form class="form" ref="form" @submit.prevent="handleSubmit">
							<v-file-input
								:label="$t('Выберите ЭЦП')"
								accept=".p12"
								:rules="[v => !!v || $t('Выберите ЭЦП')]"
								@change="toBase64"
								>
							</v-file-input>
							<v-text-field
							class="mt-3"
								:label="$t('Пароль')"
								prepend-icon="mdi-key"
								v-model="ecpPassword"
								:type="showPassword ? 'text' : 'password'"
								:append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
								:rules="[v => !!v || $t('Введите пароль')]"
								@click:append="showPassword = !showPassword"
							></v-text-field>

								<v-btn
									block
									depressed
									dark
									class="submit-btn mt-6"
									type="submit"
									:loading="loading">
								{{ $t('Войти') }}
								</v-btn>
						</v-form>
					</div>
				</v-col>
			</v-row>

		</v-container>
	</v-app>
</template>

<script>
	export default {
		mounted() {
			
		},
		computed: {
			selectedLanguage() {
				return this.$store.getters.getLanguage;
			}
		},

		data: () => ({
			showPassword: false,
			ecpFileData: '',
			ecpPassword: '',
			loading: false,
			languages: {
				'kk': 'Қазақша',
				'ru': 'Русский'
			}
		}),
		methods: {
			async handleSubmit() {
				if(this.$refs.form.validate()) {
					this.loading = true;
					await this.$http.post('/login/ecp', {
						"base64": this.ecpFileData,
						"password": this.ecpPassword
					}).then((response) => {
						if(response.data?.status == 1) {
							this.$store.dispatch('login', response).then(() => {
								this.$router.push({ path: '/' });
							});
						} else {
							this.$store.dispatch('alertAdd', {
								text: this.$t("<b>Сіз жұмыссыздар тізіміне тіркелгендер кезегінде жоқсыз.</b><br>Кезекке тіркелу үшін  <a href='/reg.html'>Өтінім жолдау</a> қажет."), 
								type:'warning',
								duration: 15000
							});
						}
					}).catch(() => {});
					this.loading = false;
				}
			},
			toBase64(file) {
				if(file) {
					const reader = new FileReader();
					reader.readAsDataURL(file);
					reader.onload = () => {
						let encoded = reader.result.toString().replace(/^data:(.*,)?/, '');
						if ((encoded.length % 4) > 0) {
							encoded += '='.repeat(4 - (encoded.length % 4));
						}
						this.ecpFileData = encoded;
					};
				}
			},
			changeLanguage(lang) {
				this.$store.commit('setLanguage', lang);
				location.reload();
			}
		},
		watch: {
			
		}
	};
</script>

<style scoped>
	.auth-block {
		background-color: #fff;
		border-radius: 20px;
		padding: 50px 60px;
		margin-top: 16vh;
	}
	.v-btn.lang-btn {
		background-color: #0075FF;
		border-radius: 10px;
		padding: 20px 50px;
	}
	.v-btn.submit-btn {
		background-color: #0075FF;
		border-radius: 10px;
		height: 44px;
	}
</style>